export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_8ae260f0-22ee-44d0-9c89-473465a85454/artifacts/q2170rih_Luna%20Markab.png";

export const CONTACT = {
    direccion:
        "Calle Juan Ruiz de Alarcon 129A, int. 3, C.P. 44150, Guadalajara, Jalisco, México.",
    telefono: "3331389963",
    email: "contacto@lunamarkab.com",
    web: "lunamarkab.com",
};

export const NAV_LINKS = [
    { label: "Inicio", href: "#inicio" },
    { label: "Nosotros", href: "#nosotros" },
    { label: "Distintivos", href: "#distintivos" },
    { label: "Servicios", href: "#servicios" },
    { label: "Proyectos", href: "#proyectos" },
    { label: "Contacto", href: "#contacto" },
];

export const ABOUT_TEXT = [
    "En Publicitaria Luna Markab, somos expertos en el arte de hacer que el mundo hable de tu marca. Nos especializamos en el diseño y despliegue de publicidad de alto impacto, dominando con maestría tanto el plano físico —desde espectaculares hasta material publicitario táctil— como el ecosistema digital más avanzado y actual.",
    "En luna Markab no solo comunicamos, sino que posicionamos marcas en el centro de la conversación digital mediante estrategias que combinan creatividad pura, presencia masiva en medios y el poder predictivo de la Inteligencia Artificial para conquistar mercados.",
];

export const MISION =
    "Empoderar a las empresas y sus marcas mediante soluciones publicitarias disruptivas y estrategias de marketing de alta precisión, facilitando su transición hacia la era de la Inteligencia Artificial con creatividad y resultados medibles y alcanzables.";

export const VISION =
    "Convertirnos en la agencia de publicidad de Guadalajara más influyente de la era digital, redefiniendo los estándares de creatividad y efectividad publicitaria para marcas que aspiran al reconocimiento y la excelencia global.";

export const DISTINTIVOS = [
    {
        n: "01",
        title: "Dominio Publicitario Total",
        body: "Nuestra capacidad de ejecutar publicidad física masiva y campañas digitales sincronizadas garantiza que tu mensaje sea omnipresente y visualmente imbatible.",
        color: "orange",
    },
    {
        n: "02",
        title: "Inteligencia Artificial Creativa",
        body: "Utilizamos IA no solo para segmentar, sino para generar piezas publicitarias disruptivas que conectan con los deseos subconscientes de tu audiencia en tiempo real.",
        color: "teal",
    },
    {
        n: "03",
        title: "Poder de Representación en Medios",
        body: "No solo creamos el anuncio; tenemos los contactos y la fuerza en relaciones públicas para colocarlo en los espacios de mayor audiencia y prestigio.",
        color: "gold",
    },
    {
        n: "04",
        title: "Diseño Orientado a la Venta",
        body: "Cada trazo gráfico y cada línea de copy están diseñados bajo principios de neuromarketing, asegurando que tu inversión publicitaria se traduzca en resultados económicos directos.",
        color: "navy",
    },
];

export const SERVICIOS = [
    {
        title: "Publicidad Física y BTL",
        body: "Diseño y producción de espectaculares, vallas, material POP y activaciones de marca que generan un impacto visual inolvidable en el mundo real.",
    },
    {
        title: "Marketing Digital y eCommerce",
        body: "Gestión de campañas de alto rendimiento en redes sociales, buscadores y plataformas de venta en línea, optimizadas para una conversión máxima.",
    },
    {
        title: "Diseño Gráfico Publicitario",
        body: "Creación de identidades visuales, catálogos y piezas creativas que comunican el valor premium de tu marca con una estética de vanguardia.",
    },
    {
        title: "Estrategias con Inteligencia Artificial",
        body: "Implementación de IA para la automatización de anuncios, análisis predictivo de tendencias y creación de experiencias de marketing hiper-personalizadas.",
    },
    {
        title: "Relaciones Públicas y Medios",
        body: "Representación profesional ante medios de comunicación y gestión de prensa para blindar y potenciar la reputación pública de tu empresa.",
    },
];

export const PROYECTOS = [
    {
        title: "Campañas Nacionales de Lanzamiento",
        body: "Diseño, desarrollo y despliegue masivo de publicidad en medios tradicionales y digitales para introducir nuevos productos al mercado con una visibilidad total.",
        img: "https://customer-assets.emergentagent.com/job_luna-markab-retro/artifacts/msfgw536_campanas-nacionales-lanzamiento.webp",
    },
    {
        title: "Ecosistemas de Venta Automatizada",
        body: "Desarrollo de infraestructuras de marketing y publicidad digital que funcionan 24/7, atrayendo prospectos y cerrando ventas mediante algoritmos inteligentes.",
        img: "https://customer-assets.emergentagent.com/job_luna-markab-retro/artifacts/ubzlnh0a_ecosistemas-venta-automatizado.webp",
    },
    {
        title: "Rediseño y Reposicionamiento de Marca",
        body: "Proyectos integrales que modernizan la imagen publicitaria de empresas consolidadas para conectar con nuevas generaciones de consumidores.",
        img: "https://customer-assets.emergentagent.com/job_luna-markab-retro/artifacts/jhibihcv_posicionamiento-marca.webp",
    },
    {
        title: "Producción de Contenido Viral y Multimedia",
        body: "Creación de videos publicitarios, fotografía comercial y contenido para redes sociales diseñado específicamente para ser compartido y generar engagement masivo.",
        img: "https://customer-assets.emergentagent.com/job_luna-markab-retro/artifacts/glh75xqm_produccion-contenido-viral-multimedia.webp",
    },
    {
        title: "Estrategias de Branding de Alto Impacto",
        body: "Proyectos de identidad corporativa donde el diseño gráfico y la psicología publicitaria se unen para crear marcas memorables y altamente competitivas.",
        img: "https://customer-assets.emergentagent.com/job_luna-markab-retro/artifacts/yjbfq2iz_branding-alto-impacto.webp",
    },
];
